import React from "react";
import "./levels.css";

const LevelSelector = props => {
  const jdkLevels = props.levels.filter(l => l.LevelGroup == "JDK").map(l => {
    return (
      <div className="level-item" onClick={() => props.selectLevel(l)} key={l.ID}>
        <img className="rank-image" src={"/" + l.LevelImage} />
        <h1>{l.LevelTitle}</h1>
      </div>
    );
  });

  const juniorLevels = props.levels.filter(l => l.LevelGroup == "Junior").map(l => {
    return (
      <div className="level-item" onClick={() => props.selectLevel(l)} key={l.ID}>
        <img className="rank-image" src={"/" + l.LevelImage} />
        <h1>{l.LevelTitle}</h1>
      </div>
    );
  });

  return (
    <div className="level">
      <h1>Jundokan Danmark</h1>
      <div className="level-selector">{jdkLevels}</div>
      <h1>Junior / Børnegrader</h1>
      <div className="level-selector">{juniorLevels}</div>
    </div>
  );
};

export default LevelSelector;
